import React from "react";
import RequestTypeBadge from "./RequestTypeBadge";
import CalendarStatusBadge from "./CalendarStatusBadge";
import { getCalendarRowBadges } from "../../utils/calendarRowBadges";

const CalendarRowBadgeStack = ({ row, isAdmin, today, className = "", compact = false }) => {
  const { requestType, primary, secondary } = getCalendarRowBadges(row, { isAdmin, today });

  return (
    <div
      className={`ml-auto flex flex-shrink-0 flex-wrap items-start justify-end gap-1.5 ${compact ? "max-w-[11rem]" : ""} ${className}`}
    >
      {isAdmin && requestType ? <RequestTypeBadge requestType={requestType} /> : null}
      <CalendarStatusBadge status={primary} secondary={secondary} />
    </div>
  );
};

export default CalendarRowBadgeStack;
